export default __webpack_public_path__ + "static/orchestra-07a2f97fd9e83c6b6aca55f3ac931315.jpg";